import { SOCOTEC_GROUPS } from "@/models/enums/UserRoles";
import { Model } from "pinia-orm";

export default class User extends Model {
  static entity = "users";
  static primaryKey = "uuid";

  static fields() {
    // Since we don't have direct access to BaseUser fields,
    // we need to define them here based on what's typically used
    return {
      uuid: this.uid(""),
      email: this.string(""),
      agency: this.attr(null),
      firstName: this.string(""),
      lastName: this.string(""),
      fullName: this.string(""),
      telephoneNumber: this.string(""),
      socotecCode: this.string(""),
      groups: this.attr([]),
      isCurrentUser: this.boolean(false),
      certificationNumber: this.string(""),
      signature: this.string(""),
      usermanagementUuid: this.string(""),
    };
  }

  isInGroup(group) {
    return this.groups && Array.isArray(this.groups) && this.groups.includes(group);
  }

  isDev() {
    return this.isInGroup(SOCOTEC_GROUPS.DEV);
  }

  isManager() {
    return this.isInGroup(SOCOTEC_GROUPS.APP_MANAGER);
  }

  isMaterialManager() {
    return this.isInGroup(SOCOTEC_GROUPS.MATERIAL_MANAGER);
  }

  isAdmin() {
    return this.isManager() || this.isDev();
  }

  isPrivileged() {
    return this.isAdmin() || this.isMaterialManager();
  }
}
